var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Button_",
    "data-name": "Button +",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    fill: "none",
    stroke: "#1d4681",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(-338 -194)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 12,
    transform: "translate(352 214)",
    fill: "none",
    stroke: "#1d4681",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    y2: 12,
    transform: "translate(358 208)",
    fill: "none",
    stroke: "#1d4681",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAdd);
export default __webpack_public_path__ + "static/media/ico-add.e8540d857285263e5d663fecc55ba970.svg";
export { ForwardRef as ReactComponent };